import { Expose, Transform } from 'class-transformer'
import { WritersPaymentStatusEnum } from '@interfaces/WritersPaymentStatusEnum'

export class WriterSalesReportsType {
  @Expose() writerTaxId: string

  @Expose() writerSendAddress: string

  @Expose()
  @Transform(({ value }) => (value ? Number(value) : 0))
  writerIncomeSummary: number

  @Expose()
  @Transform(({ value }) => (value ? Number(value) : 0))
  writerIncomeNovelEbook: number

  @Expose()
  @Transform(({ value }) => (value ? Number(value) : 0))
  writerIncomeNovelChapter: number

  @Expose()
  @Transform(({ value }) => (value ? Number(value) : 0))
  writerIncomeMangaEbook: number

  @Expose()
  @Transform(({ value }) => (value ? Number(value) : 0))
  writerIncomeDonation: number

  @Expose()
  @Transform(({ value }) => (value ? Number(value) : 0))
  writerIncomeMangaChapter: number

  @Expose()
  @Transform(({ value }) => (value ? Number(value) : 0))
  writerIncomeCumulative: number

  @Expose() writerFullName: string

  @Expose()
  @Transform(({ value }) => (value ? Number(value) : 0))
  withholdingTax: number

  @Expose() paymentCycleYear: number

  @Expose() paymentCycleMonth: number

  @Expose() status: WritersPaymentStatusEnum

  @Expose() paidAt: string

  @Expose()
  @Transform(({ value }) => (value ? Number(value) : 0))
  paidAfterDeductWithholdingTax: number

  @Expose() createdAt: string

  @Expose()
  @Transform(({ value }) => (value ? Number(value) : 0))
  totalIncomeBeforeDeductWithholdingTax: number
}
